import {Component, Input, OnInit} from '@angular/core';
import {NgSwitch, NgSwitchCase} from '@angular/common';

export enum LoginErrorState {
  DISALLOWED_IPADDRESS = 'DISALLOWED_IPADDRESS',
  PASSWORD_EXPIRED = 'PASSWORD_EXPIRED',
  ACCOUNT_DISABLED = 'ACCOUNT_DISABLED',
  DEFAULT_LOGIN_FAILURE = 'DEFAULT_LOGIN_FAILURE',
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
  DISALLOWED_EMPLOYEE_LOGIN = 'DISALLOWED_EMPLOYEE_LOGIN',
  OTP_FAILURE = 'OTP_FAILURE',
}

@Component({
  selector: 'error-container',
  templateUrl: './error-container.component.html',
  styleUrls: ['./error-container.component.scss'],
  standalone: true,
  imports: [NgSwitch, NgSwitchCase]
})
export class ErrorContainerComponent implements OnInit {
  @Input()
  public errorState;

  public loginErrorState = LoginErrorState;
  public readonly disabled = 'disabled';
  public readonly passwordExpired = 'passwordExpired';
  public readonly serverException = 'serverException';
  public readonly unauthorizedIp = 'unauthorizedIp';
  public readonly invalidLogin = 'invalidLogin';
  public emoji = '&#128522;';

  constructor() {
  }

  ngOnInit() {
  }
}
